import AuthService from "../../services/login/auth.service";
import { comprobantes ,cuentas,transferencias } from "../../components/generico/utils/UrlAPI";
import axios from "axios";

class TransferCuentasPropiasService {
  async getCuentas(tipoCuenta) {
    if(tipoCuenta === "D"){
      var data = JSON.stringify({
        canal: "WEB",
        tipo: tipoCuenta,
        estado: null, 
        modalidad: null,
        moneda: null,  
        tipoCuenta: null
      });
    }else if(tipoCuenta === "I"){
      var data = JSON.stringify({
        canal: "WEB",
        tipo: "D",
        estado: null, 
        modalidad: null,
        moneda: "GS",  
        tipoCuenta: null
      });
    }else{
      var data = JSON.stringify({
        canal: "WEB",
        tipo: "T",
        estado: null, 
        modalidad: null,
        moneda: null,  
        tipoCuenta: null
      });
    }
    var config = {
      method: "post",
      url: cuentas+"socio-cuenta/transferencias",
      headers: {
        "Content-Type": "application/json",
          Authorization: "Bearer "+AuthService.getCurrentToken()
      },
      data: data
    };

    

    return await axios(config);
  }
  async transferir(ctaDebito, ctaCredito, monto) {
    var data = JSON.stringify({
      cuentaDebito: ctaDebito,
      cuentaCredito: ctaCredito.cuenta,
      importe: monto,
      canal: "WEB",
      tipoCuenta: ctaCredito.tipoCuenta,
      plan:ctaCredito.plan,
      grupo: ctaCredito.grupo,
      tipoTransferencia: "TC",
      pin: null
    });
    //console.log(monto)
    var config = {
      method: "post",
      url: transferencias+"transferencia",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer "+AuthService.getCurrentToken()
      },
      data: data,
    };

    return await axios(config);
  }

  async descagarComponente(titulo, nroOperacion, cuentaTitular, tipo, moneda, cuentaDebito,cuentaCredito,importeDebito, importeCredito, titularCuentaDestino) {
    
    var _url = comprobantes + "/comprobantes/v2/transferencias";

    var data = JSON.stringify({
      titulo: titulo,
      nroOperacion: nroOperacion,
      cuentaTitular: cuentaTitular,
      tipo: tipo,
      moneda: moneda,
      cuentaDebito: cuentaDebito,
      cuentaCredito: cuentaCredito,
      importeDebito: importeDebito,
      importeCredito: importeCredito,
      titularCuentaDestino: titularCuentaDestino
    });
      

    var config = {
      method: "post",
      url: _url,
      responseType: "blob",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
      data: data,
    };
    return await axios(config);
  
}

}
export default new TransferCuentasPropiasService();
